module.exports = __webpack_public_path__ + "static/media/bw.9c6e7340.svg";